import angular from "angular"

angular.module("uCountitUiApp").factory("NewOverviewSrv", function ($rootScope, $resource) {
  const Store = $resource(
    $rootScope.globalConfig.apipath + "/store/:id/smsNoti",
    { id: this.id },
    {
      get: {
        method: "GET",
      },
      update: {
        method: "PUT",
      },
    }
  )

  const Addressbook = $resource(
    "",
    {},
    {
      getByStore: {
        method: "GET",
        url: $rootScope.globalConfig.apipath + "/addressbook/store/:id",
      },
      create: {
        method: "POST",
        url: $rootScope.globalConfig.apipath + "/addressbook/store/:id",
      },
      updateBulk: {
        method: "PUT",
        url: $rootScope.globalConfig.apipath + "/addressbook/store/:id/bulk",
      },
      delete: {
        method: "DELETE",
        url: $rootScope.globalConfig.apipath + "/addressbook/store/:id",
      },
    }
  )

  return {
    Store,
    Addressbook,
  }
})
